import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { IDI_INSPECTOR_DETAIL_SEARCH_START_LOADING, IDI_INSPECTOR_DETAIL_SEARCH_END_LOADING, IDI_INSPECTOR_DETAIL_SEARCH_LOADED, SET_IDI_INSPECTOR_DETAIL_FILTER } from "../constants/IdiInspectorDetailConstants";
import { IDI_INSPECTOR_DETAIL_START_LOADING, IDI_INSPECTOR_DETAIL_END_LOADING, IDI_INSPECTOR_DETAIL_LOADED } from "../constants/IdiInspectorDetailConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null,
};

const IdiInspectorDetailReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_INSPECTOR_DETAIL_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_INSPECTOR_DETAIL_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case IDI_INSPECTOR_DETAIL_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_IDI_INSPECTOR_DETAIL_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case IDI_INSPECTOR_DETAIL_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case IDI_INSPECTOR_DETAIL_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case IDI_INSPECTOR_DETAIL_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IdiInspectorDetailReducer;